import { VossProductGroupType } from "../../../Constants/VOSS/vossProductGroupType";
import { VossProductType } from "../../../Constants/VOSS/vossProductType";
import { FormInput } from "../../FormComponents/Input/Input";
import { ProductGroupCard } from "../ProductGroupCard";
import React from "react";

const mainPricingTableConfig = [
    { header: "Articles", key: "name", type: "text", className: "col-3", productInfo: true },
    { header: "Article number", key: "articleNumber", type: "text", className: "col-3", productInfo: true },
    { header: "Price", key: "price", type: "input", disabled: true, className: "col" },
    { header: "Percentage", key: "percentage", type: "input", disabled: false, className: "col" },
];

const usagePricingTableConfig = [
    { header: "Usage", key: "name", type: "text", className: "col-4", productInfo: true },
    { header: "Article number", key: "articleNumber", type: "text", className: "col-4", productInfo: true },
    { header: "Price", key: "price", type: "input", className: "col" },
];

export default function ProductGroupPriceAdjustment({ productGroupPricings, tier }) {

    const included = productGroupPricings.filter((pg) => pg.type === VossProductGroupType.Included);
    const optional = productGroupPricings.filter((pg) => pg.type !== VossProductGroupType.Included);

    const getProductGroup = (id) => tier.productGroups.find((pg) => pg.id === id);

    return <div className="d-flex flex-column gap-32">
        <div className="d-grid grid-cols-2 gap-32">
            <ProductGroups productGroupPricings={included} getProductGroup={getProductGroup} />
        </div>
        <div className="border-bottom" />
        <div className="d-grid grid-cols-2 gap-32">
            <ProductGroups productGroupPricings={optional} getProductGroup={getProductGroup} />
        </div>
    </div>
}

function ProductGroups({ productGroupPricings, getProductGroup }) {

    return <>
        {productGroupPricings.map((pricing, index) => {
            const group = getProductGroup(pricing.id);
            const getProduct = (id) => group.products.find((p) => p.id === id);

            const licenseProducts = pricing.products.filter((p) => (p.type === VossProductType.License));
            const mainProducts = pricing.products.filter((p) => (p.type === VossProductType.Main || p.type === VossProductType.Addon));
            const usageProducts = pricing.products.filter((p) => (p.type === VossProductType.Usage));

            return <ProductGroupCard key={index} productGroup={group}>
                <form className="skynet-form disabled">
                    <div className="d-grid row gap-16">
                        <div className="col m-0 p-0">
                            <fieldset className="d-grid gap-16 mb-0">
                                <FormInput value={pricing.publishedPrice} disabled label="Published price" />
                                <FormInput label="Price" value={pricing.price} />
                                {mainProducts.length > 0 && <UnitPricingTable
                                    products={mainProducts}
                                    getProduct={getProduct}
                                    config={mainPricingTableConfig}
                                />}
                                {usageProducts.length > 0 &&
                                    <UnitPricingTable
                                        products={usageProducts}
                                        getProduct={getProduct}
                                        config={usagePricingTableConfig}
                                    />}
                                {licenseProducts.length > 0 &&
                                    <TieredPricingTable products={licenseProducts} getProduct={getProduct}
                                    />}
                            </fieldset>
                        </div>
                    </div>
                </form>
            </ProductGroupCard>
        })}
    </>
}

function UnitPricingTable({ products, getProduct, config }) {
    return <table className="table mb-0 shadow-0 skynet-table-no-divider table-stripe border-0">
        <thead>
            <tr>
                {config.map((col, idx) => (
                    <th key={idx} className={col.className}>{col.header}</th>
                ))}
            </tr>
        </thead>
        <tbody>
            {products.map((pricing, rowIndex) => {
                const product = getProduct(pricing.id);
                return (
                    <tr key={rowIndex}>
                        {config.map((col, colIndex) => {
                            const value = col.productInfo ? product[col.key] : pricing[col.key];
                            if (col.type === "input") {
                                return (
                                    <td key={colIndex} className={col.className}>
                                        <FormInput disabled={col.disabled} value={value} />
                                    </td>
                                );
                            } else {
                                return (
                                    <td key={colIndex} className={col.className}>
                                        {value}
                                    </td>
                                );
                            }
                        })}
                    </tr>
                );
            })}
        </tbody>
    </table>
}

function TieredPricingTable({ products, getProduct }) {
    return (
        <div className="d-grid gap-16">
            <table className="table mb-0 shadow-0 skynet-table-no-divider table-stripe border-0">
                <thead>
                    <tr>
                        <th className="col-4">License</th>
                        <th className="col-4">Article number</th>
                        <th className="col">Price</th>
                    </tr>
                </thead>
                <tbody>
                    {products.map((pricing) => {
                        const product = getProduct(pricing.id);
                        return (
                            <React.Fragment key={product.id}>
                                <tr>
                                    <td className="col-3"><strong>{product.name}</strong></td>
                                    <td className="col-4" colSpan={2}>{product.articleNumber}</td>
                                </tr>
                                {pricing.tierPricing.map((tier, index) => (
                                    <tr key={index}>
                                        <td className="col-7" colSpan={2}>
                                            {tier.index + " - " + (tier.upperLimit ?? "No limit")}
                                        </td>
                                        <td>
                                            <FormInput value={(tier.unitPrice ?? tier.flatPrice) ?? "0"} className="col" />
                                        </td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}